import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import * as ConstantsStore from '../../../store/constants';
import * as App from '../../../store/app';
import * as Admin from '../../../store/admin';

import { EditRequirementTypeDocumentRestrictions } from '@components/admin/requirementTypes/EditRequirementTypeDocumentRestrictions';

export default connect(
    (state: ApplicationState) => ({
        ...Admin.plainActions,
    }),
    {},
)(EditRequirementTypeDocumentRestrictions as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
